(function () {
  document.addEventListener("pointerenter", (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const element = event.target.closest("[data-prefetch]");

    if (!element) {
      return;
    }

    if (element.dataset.prefetched) {
      return;
    }

    prefetch(element.href);
  });

  function prefetch(url, as = "document") {
    const link = document.createElement("link");

    link.rel = "prefetch";
    link.href = url;
    link.as = as;

    document.head.appendChild(link);
  }
})();
